export default __webpack_public_path__ + "static/media/0016.ef0503e2.svg";